// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qx3Alk3e{position:absolute;font-size:4px;top:-6px;padding-left:16px;color:var(--color-text-dark-secondary);z-index:1000}`, "",{"version":3,"sources":["webpack://./src/components/TelegramId/styles.module.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,aAAA,CACA,QAAA,CACA,iBAAA,CACA,sCAAA,CACA,YAAA","sourcesContent":[".text {\n  position: absolute;\n  font-size: 4px;\n  top: -6px;\n  padding-left: 16px;\n  color: var(--color-text-dark-secondary);\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `Qx3Alk3e`
};
export default ___CSS_LOADER_EXPORT___;
